import { Injectable, inject } from '@angular/core';
import { FlexiLogicResult } from '@customer-apps/flexi-logic';
import { TemplateSlot } from '../interfaces';
import { ContextModelService } from './context-model.service';

@Injectable({ providedIn: 'root' })
export class SlotService {
    private contextModelService = inject(ContextModelService);

    isSlotHidden(slot: TemplateSlot | undefined): FlexiLogicResult | null {
        if (!slot?.isHidden) {
            return false;
        }
        return this.contextModelService.processJsonLogic(slot.isHidden);
    }
}
